<script setup lang="ts">
import { onUnmounted, ref, watch } from "vue";
import { lerpMap, maxDotNumber, stepMap } from "@zyzgroup/core-common";
import { getCSSVar, injectStyle } from "@zyzgroup/core-web";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    min?: number;
    max?: number;
    step?: number;
    defaultValue?: number;
    unit?: string;
    showValue?: boolean;
    autofocus?: boolean;
    color?: string;
    barColor?: string;
    handleSize?: number;
    barHeight?: number;
  }>(),
  {
    min: 0,
    max: 100,
    step: 1,
    defaultValue: 0,
    unit: "",
    showValue: true,
    autofocus: false,
    color: getCSSVar("--yz-xg-blue", "#5a82f0"),
    barColor: "#f5f5f5",
    handleSize: 20,
    barHeight: 4
  }
);

const emits = defineEmits<{
  (event: "change", value: number): void;
}>();

const getStep = stepMap(props.min, props.max, props.step);
const getPercent = lerpMap(props.min, props.max, 0, 100);

const value = ref(getStep(props.defaultValue));
const percent = ref(maxDotNumber(getPercent(value.value), 2));

function change(e: Event) {
  value.value = getStep(parseFloat((e.target as HTMLInputElement).value));
  percent.value = maxDotNumber(getPercent(value.value), 2);
  emits("change", value.value);
}

const r = ref();
watch(r, () => {
  if (!r.value) {
    return;
  }
  /// for ce
  injectStyle(
    `
  :root {
    --input-range-color: ${props.color};
    --input-range-thumb-size: ${props.handleSize}px;
    --input-range-thumb-top: ${(props.handleSize - props.barHeight) * -0.5}px;
    --input-range-track-size: ${props.barHeight}px;
  }
  :host {
    --input-range-color: ${props.color};
    --input-range-thumb-size: ${props.handleSize}px;
    --input-range-thumb-top: ${(props.handleSize - props.barHeight) * -0.5}px;
    --input-range-track-size: ${props.barHeight}px;
  }
`,
    r.value
  );
});

onUnmounted(() => {});

defineExpose({});
</script>

<template>
  <div
    class="input-range"
    ref="r"
    :style="{ height: props.handleSize + 'px' }"
  >
    <input
      type="range"
      :max="props.max"
      :min="props.min"
      :step="props.step"
      :value="value"
      :autofocus="props.autofocus"
      @input="change"
      :style="{
        background: `linear-gradient(to right, ${props.color} 0%, ${props.color} ${percent}%, ${props.barColor} ${percent}%, ${props.barColor})`
      }"
    />
    <!-- <slot :value="value">
      <label
        class="label"
        v-if="showValue"
      >
        {{ value }}{{ props.unit }}
      </label>
    </slot> -->
  </div>
</template>

<!--
  ce 中不要使用v-bind
-->
<style scoped>
.input-range {
  position: relative;
  box-sizing: border-box;
  font-size: 1em;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  overflow: hidden;
}
.label {
  min-width: 3em;
  text-align: right;
}
input[type="range"] {
  flex: 1 1 auto;
  -webkit-appearance: none;
  appearance: none;
  border-radius: 9999px;
  margin: 0;
  padding: 0;
  position: relative;
}
input[type="range"]:focus {
  outline: none;
}
/*
input[type="range"]::-webkit-slider-container {
  overflow: hidden;
}
*/
input[type="range"]::-webkit-slider-runnable-track {
  height: var(--input-range-track-size);
  border-radius: 9999px;
}
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  height: var(--input-range-thumb-size);
  width: var(--input-range-thumb-size);
  margin-top: var(--input-range-thumb-top);
  background: var(--input-range-color);
  border-radius: 50%;
  cursor: pointer;
}
</style>
